const ehandoverIds = {
  ehandover_btn: 'ehandover_btn',
  login: 'login_',
  staff: 'staff',
  createNote: 'createNote',
  checklist: 'checklist',
  checklist_delete: 'checklist_delete',
  tag_delete: 'tag_delete',
  filter: 'filter',
  tag_filter: 'tag_filter',
  taskItem: 'taskItem',
  comment: 'comment',
  addComment: 'addComment',
  checkNote: 'checkNote',
  drop: 'drop',
  inputReset: 'ehandover_create_input_reset',
};

export default ehandoverIds;
